// extracted by mini-css-extract-plugin
export var banner = "_ga-0";
export var closeButton = "_ga-2";
export var greenCheckmark = "_ga-3";
export var hereLink = "_ga-4";
export var titleIcon = "_ga-1";